<div class="ptb-archive" *ngIf="isArchive">
  <div class="mt-12 ml-1-5 archive-banner">
    <div class="archive-btn">
      <span class="version-general-header">Archive Version : {{archiveVersion}}</span>
    </div>
    <div role="button" class="back-close-btn" tabindex="0" (click)="BackToCurrentContent()" (keyup.enter)="BackToCurrentContent()" tabindex="0">
      <img src="../../../assets/icons/arrow-left-blue.svg" class="current-content-back-arrow-icon" alt="Arrow Left">
      <span class="underline">Back to Current GARS Version</span>
    </div>
  </div>
</div>
<div class="ml-4 print-content print-all-content pt-3">
  <div class="mb-2 paraHeader" id="tableOfContents">
    <app-breadcrumbs-path [crumbData]="navData.crumbData"></app-breadcrumbs-path>
    <span class="generalHeader">{{dataSource.data[0].item}}</span>
  </div>
  <div class="mt-2 mb-2">
    <div class="paraHeader mb-1">Table of Contents</div>
    <div><span class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="showAllInOnePage()" (keyup.enter)="showAllInOnePage()" tabindex="0"> Show All in One Page </span></div>
    <div class="flex-display">
      <div class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="tree.treeControl.collapseAll()" (keyup.enter)="tree.treeControl.collapseAll()" tabindex="0"> Collapse</div>
      <div class="mt-1rem">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
      <div class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="tree.treeControl.expandAll()" (keyup.enter)="tree.treeControl.expandAll()" tabindex="0"> Expand </div>
    </div>
  </div>
  <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <div class="mat-tree-node" *ngIf="node.itemData?.length > 0 && node.rollUp != 'True'">
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.item">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <span class="font-16">{{node.item}}</span>
      </div>
      <div class="mat-tree-node" *ngIf="node.rollUp == 'True' && node.itemData?.length > 0">
        <span class="highlight-blue border-bottom-help cursor-pointer singleLine" (click)="navigateToUrl(node.itemLink)">{{node.item}}</span>
      </div>
      <div class="mat-tree-node" *ngIf="node.itemData?.length == 0">
        <span class="highlight-blue border-bottom-help cursor-pointer singleLine" *ngIf="node.itemData?.length == 0" (click)="navigateToUrl(node.itemLink)">{{node.item}}</span>
      </div>
      <!-- There is inline padding applied to this div using styles.
      This padding value depends on the mat-icon-button width.  -->
      <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
           role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</div>
